import React, { useEffect, useState } from 'react';
import PropTypes from "prop-types";
import { useHistory, withRouter } from "react-router-dom";
import ConfigData from "../config.json"
import axios from "axios";


import Header from './header';
import Sidebar from './sidebar';
import Footer from './footer';

import {
    changeLayout,
    changeSidebarTheme,
    changeLayoutMode,
    changeLayoutWidth,
    changeLayoutPosition,
    changeTopbarTheme,
    changeLeftsidebarSizeType,
    changeLeftsidebarViewType,
    changeSidebarImageType
} from "../stores/actions";
import { useDispatch, useSelector } from 'react-redux';

const MasterPage = (props) => {
    const [headerClass, setHeaderClass] = useState("");
    const [locationState, setLocationState] = useState("");
    const dispatch = useDispatch();
    const history = useHistory();

    const {
        layoutType,
        leftSidebarType,
        layoutModeType,
        layoutWidthType,
        layoutPositionType,
        topbarThemeType,
        leftsidbarSizeType,
        leftSidebarViewType,
        leftSidebarImageType
    } = useSelector(state => ({
        layoutType: state.Layout.layoutType,
        leftSidebarType: state.Layout.leftSidebarType,
        layoutModeType: state.Layout.layoutModeType,
        layoutWidthType: state.Layout.layoutWidthType,
        layoutPositionType: state.Layout.layoutPositionType,
        topbarThemeType: state.Layout.topbarThemeType,
        leftsidbarSizeType: state.Layout.leftsidbarSizeType,
        leftSidebarViewType: state.Layout.leftSidebarViewType,
        leftSidebarImageType: state.Layout.leftSidebarImageType,
    }));

    useEffect(() => {
        if (
            layoutType ||
            leftSidebarType ||
            layoutModeType ||
            layoutWidthType ||
            layoutPositionType ||
            topbarThemeType ||
            leftsidbarSizeType ||
            leftSidebarViewType ||
            leftSidebarImageType
            ) {
            dispatch(changeLeftsidebarViewType(leftSidebarViewType));
            dispatch(changeLeftsidebarSizeType(leftsidbarSizeType));
            dispatch(changeSidebarTheme(leftSidebarType));
            dispatch(changeLayoutMode(layoutModeType));
            dispatch(changeLayoutWidth(layoutWidthType));
            dispatch(changeLayoutPosition(layoutPositionType));
            dispatch(changeTopbarTheme(topbarThemeType));
            dispatch(changeLayout(layoutType));
            dispatch(changeSidebarImageType(leftSidebarImageType))
        }
    }, [layoutType,
        leftSidebarType,
        layoutModeType,
        layoutWidthType,
        layoutPositionType,
        topbarThemeType,
        leftsidbarSizeType,
        leftSidebarViewType,
        leftSidebarImageType,
        dispatch
    ]);
    
    const onChangeLayoutMode = (value) => {
        if (changeLayoutMode) {
            dispatch(changeLayoutMode(value));
        }
    };

    useEffect(() => {
        window.addEventListener("scroll", scrollNavigation, true);

        history.listen((location, action) => {
            setLocationState(location.pathname);
        });
    });

    useEffect(() => {
        const token = (!sessionStorage.getItem("token")) ? null : sessionStorage.getItem("token");
        if(token === "" || token === null || typeof(token) === "undefined"){
            history.push("/login");
        }else{
            let expire = checkTokenExpire(token);
            if(expire !== true){
                history.push("/login");
            }
        }
    }, [locationState]);

    function scrollNavigation() {
        var scrollup = document.documentElement.scrollTop;
        if (scrollup > 50) {
            setHeaderClass("topbar-shadow");
        } else {
            setHeaderClass("");
        }
    }

    const checkTokenExpire = (tokens) => {
        // let url = ConfigData.API_URL_AUTHEN + "api/token-expire";
        // let token = "Bearer " + tokens;
        // try {
        //     const resp = await axios.get(url, { headers: { 
        //                         'Authorization' : token,
        //                     }, responseType: "json" }
        //                 );
        //     let respData = resp.data;
        //     // console.log(respData);
        //     return respData.is_sucess;
        // }catch(error){
        //     // console.log(error.response.data);
        //     return false;
        // }
        const decodeJwt = parseJwt(tokens);
        if((decodeJwt.exp * 1000) < Date.now()){
            return false;
        }
        return true;
    };

    const parseJwt = (token) => {
        try {
          return JSON.parse(atob(token.split(".")[1]));
        } catch (e) {
          return null;
        }
      };

    return (
        <React.Fragment>
            <div id="layout-wrapper">
                <Header headerClass={headerClass} layoutModeType={layoutModeType} onChangeLayoutMode={onChangeLayoutMode} />
                <Sidebar layoutType={layoutType} />
                <div className="main-content">
                    {props.children}
                    {/* <Footer /> */}
                </div>
            </div>
        </React.Fragment>
    );
};

MasterPage.propTypes = {
    children: PropTypes.object,
};

export default withRouter(MasterPage);